module.exports = __webpack_public_path__ + "img/logo-partner.d519ca5c.png";